<template>
  <div class="account">
    <CCard class="card-table-account">
      <CRow>
        <CCol sm="6">
          <div class="form-group">
            <label>{{
              $t("placeholder.label_employee_search_code_name")
            }}</label>
            <CInput
              v-model="searchData.name"
              :placeholder="
                this.$t('placeholder.label_employee_search_code_name')
              "
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="6">
          <div class="form-group">
            <label>{{ $t("account.label_company_name") }}</label>
            <select
              class="form-control"
              v-model="searchData.company_code"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="key"
                v-for="(item, key, index) in companies"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("account.label_account_foot") }}</label>
            <select
              class="form-control"
              v-model="searchData.footCode"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.code"
                v-for="(item, index) in foots"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("account.label_account_division") }}</label>
            <select
              class="form-control"
              v-model="searchData.divisionCode"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.code"
                v-show="
                  item.parent_code === searchData.footCode ||
                    searchData.footCode == 0
                "
                v-for="(item, index) in divisions"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("account.label_account_position") }}</label>
            <select
              class="form-control"
              v-model="searchData.positionId"
              @change="search"
            >
              <option value="0">
                {{ $t("placeholder.label_employee_option_search") }}
              </option>
              <option
                :value="item.id"
                v-for="(item, index) in positions"
                :key="index"
                >{{ item.name }}</option
              >
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" class="text-center btn-search">
          <CButton class="btn-search-account" @click.prevent="search">{{
            $t("button.label_account_btn_search")
          }}</CButton>
          <CButton class="btn-reset" @click="resetForm">{{
            $t("button.label_action_reset")
          }}</CButton>
        </CCol>
      </CRow>
    </CCard>
    <CRow>
      <CCol sm="12">
        <CCard class="account-table">
          <CCardBody>
            <div class="option-table">
              <div class="form-group">
                <select
                  class="form-control select-per-page"
                  v-model="searchData.itemsPerPage"
                  @change="search"
                >
                  <option
                    v-for="(item, index) in listItemsPerPage"
                    :value="item"
                    :key="index"
                    >{{ item }}</option
                  >
                </select>
              </div>
              <template v-if="accounts.data && accounts.data.length > 0">
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ $t("commons.label_text_to") }}
                  {{ searchData.paginate.to }}
                  {{ $t("commons.label_text_of") }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
              <template v-else>
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ searchData.paginate.to }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
            </div>
            <div class="table-responsive">
              <table class="table table-mobile table-tablet">
                <thead>
                  <tr>
                    <th>#</th>
                    <th
                      @click="sortByColumn(columnSortArr.id)"
                      class="cl-pointer"
                    >
                      {{ $t("account.label_account_code") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('employees.id')"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSortArr.name)"
                      class="cl-pointer"
                    >
                      {{ $t("account.label_account_name") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('employees.name')"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSortArr.email)"
                      class="cl-pointer"
                    >
                      {{ $t("account.label_account_email") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('accounts.email')"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSortArr.company_name)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_company_name") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('companies.name')"
                        ></CIcon>
                      </span>
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_foot") }}
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSortArr.departments)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_employee_division") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('departments.name')"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSortArr.position_name)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_employee_position") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort('positions.name')"
                        ></CIcon>
                      </span>
                    </th>
                    <th scope="col" class="text-center">
                      {{ $t("employee.label_employee_action") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="accounts.data && accounts.data.length > 0">
                    <tr v-for="(item, index) in accounts.data" :key="index">
                      <th scope="row">
                        {{
                          (accounts.current_page - 1) * accounts.per_page +
                            index +
                            1
                        }}
                      </th>
                      <td>{{ item.employee ? item.employee.id : "" }}</td>
                      <td>{{ item.employee ? item.employee.name : "" }}</td>
                      <td>{{ item.email }}</td>
                      <td>{{ item.company_name }}</td>
                      <td>{{ item.foot }}</td>
                      <td>{{ item.division }}</td>
                      <td>{{ item.position_name }}</td>
                      <td class="py-2 d-flex justify-content-center">
                        <CButton
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                          @click.prevent="resetPassword(item.id)"
                          >{{
                            $t("button.label_account_btn_reset_password")
                          }}</CButton
                        >
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="12" class="text-center">
                        {{ $t("table.label_data_not_found") }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
          <CPagination
            :activePage.sync="searchData.paginate.currentPage"
            :pages="searchData.paginate.totalPage"
            @update:activePage="changePage"
            size="sm"
            align="center"
          />
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export default {
  name: "Accounts",
  metaInfo() {
    return {
      title: this.$t("page_title.page_account_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      searchData: {
        name: "",
        job_title_code: 0,
        company_code: 0,
        footCode: 0,
        divisionCode: 0,
        positionId: 0,
        itemsPerPage: 10,
        columnSort: "employees.id",
        sortBy: "DESC",
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      },
      columnSortArr: {
        id: "employees.id",
        name: "employees.name",
        email: "accounts.email",
        company_name: "companies.name",
        departments: "departments.name",
        position_name: "positions.name"
      }
    };
  },
  computed: {
    ...mapGetters({
      accounts: "account/accounts",
      foots: "commons/foots",
      divisions: "commons/divisions",
      positions: "commons/positions",
      jobTitle: "commons/jobTitle",
      companies: "commons/companies",
      listItemsPerPage: "commons/listItemsPerPage",
      sort: "commons/sort",
      pagination: "account/pagination"
    })
  },

  watch: {
    $route(to) {
      if (to.fullPath === "/accounts") {
        this.resetParams();
        this.fetchAccountsData();
      }
    }
  },

  methods: {
    ...mapActions("account", ["fetchAccount"]),
    ...mapActions("layout", ["setLoading"]),

    async fetchAccountsData() {
      await this.fetchAccount({
        optionPage: this.searchData.itemsPerPage,
        currentPage: this.searchData.paginate.currentPage,
        name: this.searchData.name.toLowerCase(),
        job_title_code: this.searchData.job_title_code,
        company_code: this.searchData.company_code,
        footCode: this.searchData.footCode,
        divisionCode: this.searchData.divisionCode,
        positionId: parseInt(this.searchData.positionId),
        columnSort: this.searchData.columnSort,
        sortBy: this.searchData.sortBy
      });
      this.searchData.paginate = this.pagination;
    },

    async search() {
      if (this.$route.fullPath !== "/accounts") {
        this.clearParamUrl();
      }
      this.passParamUrl();
      this.setLoading(true);
      try {
        await this.fetchAccountsData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },

    resetParams() {
      if (this.$route.fullPath !== "/accounts") {
        this.clearParamUrl();
      }
      this.searchData = {
        name: "",
        job_title_code: 0,
        company_code: 0,
        footCode: 0,
        divisionCode: 0,
        positionId: 0,
        itemsPerPage: 10,
        columnSort: "id",
        sortBy: "DESC",
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      };
    },

    resetForm() {
      (this.searchData.name = ""),
        (this.searchData.job_title_code = 0),
        (this.searchData.company_code = 0),
        (this.searchData.footCode = 0),
        (this.searchData.divisionCode = 0),
        (this.searchData.positionId = 0);
    },

    passParamUrl() {
      this.$router.push({
        name: "accounts",
        query: {
          name: this.checkDataParam(this.searchData.name),
          jobTitleCode: this.checkDataParam(this.searchData.job_title_code),
          companyCode: this.checkDataParam(this.searchData.company_code),
          footCode: this.checkDataParam(this.searchData.footCode),
          divisionCode: this.checkDataParam(this.searchData.divisionCode),
          positionId: this.checkDataParam(this.searchData.positionId),
          columnSort: this.checkDataParam(this.searchData.columnSort),
          sortBy: this.checkDataParam(this.searchData.sortBy),
          currentPage: this.checkDataParam(
            this.searchData.paginate.currentPage
          ),
          perPage: this.checkDataParam(this.searchData.itemsPerPage)
        }
      });
    },
    clearParamUrl() {
      this.$router.push({ name: "accounts" });
    },
    sortByColumn(column) {
      if (this.searchData.columnSort != column) {
        this.searchData.sortBy = "DESC";
      }
      this.searchData.columnSort = column;
      this.searchData.sortBy =
        this.searchData.sortBy === "DESC" ? "ASC" : "DESC";
      this.passParamUrl();
      this.fetchAccountsData();
    },
    classStatusSort(column) {
      return this.searchData.columnSort === column &&
        this.searchData.sortBy === "ASC"
        ? "sort-rotate"
        : "";
    },

    changePage() {
      this.passParamUrl();
      this.fetchAccountsData();
    },

    checkDataParam(data) {
      return data === 0 || data === "" ? undefined : data;
    },

    async resetPassword(accountId) {
      this.$confirm(
        this.$t("popup.label_popup_title_reset_password"),
        this.$t("button.label_account_btn_reset_password"),
        this.$t("popup.label_confirm_button_reset_password"),
        this.$t("popup.label_cancel_button"),
        "danger"
      ).then(result => {
        if (result) {
          this.setLoading(true);
          this.$store
            .dispatch("account/resetPassword", accountId)
            .then(() => {
              this.setLoading(false);
              Swal.fire(
                this.$t("popup.label_popup_success_title_reset_password")
              );
            })
            .catch(() => {
              this.setLoading(false);
              Swal.fire({
                icon: "error",
                text: this.$t("popup.label_popup_error_text")
              });
            });
        }
      });
    }
  },
  created() {
    if (Object.keys(this.$route.query).length !== 0) {
      let params = this.$route.query;
      params.perPage =
        this.listItemsPerPage.includes(parseInt(params.perPage)) &&
        !isNaN(params.perPage)
          ? params.perPage
          : 10;
      params.sortBy = this.sort.includes(params.sortBy)
        ? params.sortBy
        : "DESC";
      this.searchData = {
        name: params.name == undefined ? this.searchData.name : params.name,
        job_title_code:
          params.jobTitleCode == undefined
            ? this.searchData.job_title_code
            : params.jobTitleCode,
        company_code:
          params.companyCode == undefined
            ? this.searchData.company_code
            : params.companyCode,
        footCode:
          params.footCode == undefined
            ? this.searchData.footCode
            : params.footCode,
        divisionCode:
          params.divisionCode == undefined
            ? this.searchData.divisionCode
            : params.divisionCode,
        positionId:
          params.positionId == undefined
            ? this.searchData.positionId
            : params.positionId,
        itemsPerPage: params.perPage,
        columnSort: params.columnSort,
        sortBy: params.sortBy,
        paginate: {
          from: params.from,
          to: params.to,
          totalPage: parseInt(params.totalPage),
          path: this.searchData.paginate.path,
          currentPage: parseInt(params.currentPage),
          totalRecord: parseInt(params.totalRecord),
          perPage: parseInt(params.perPage)
        }
      };
    }
    this.fetchAccountsData();
  }
};
</script>

<style lang="scss" scoped>
.account {
  margin: -2rem -30px 30px -30px;
  .card-table-account {
    padding: 30px;
  }
  .btn-search-account {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
  }
  .account-table {
    margin: 0 20px 0 30px;
  }
  .select-per-page {
    width: 70px;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
  }
  .btn-search {
    margin-top: 15px;
  }
}
.cl-pointer {
  cursor: pointer;
  .icon-sort {
    margin-left: 5px;
    .c-icon {
      width: 12px;
    }
    .sort-rotate {
      transform: rotate(180deg);
    }
  }
}
.btn-reset {
  background-color: #e8e5e5;
  margin-left: 20px;
  padding: 8px;
  width: 120px;
}
@media only screen and (max-device-width: 767px) {
  .show-text-table {
    margin-top: 0.4rem;
  }
  .account .account-table {
    margin: 0 20px;
  }
  .table-mobile {
    width: 1100px;
    overflow-x: scroll;
  }
  .show-text-table {
    margin-left: 20px;
  }
}
@media only screen and (max-device-width: 320px) {
  .show-text-table {
    margin-top: 0;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-tablet {
    width: 1100px;
    overflow-x: scroll;
  }
}
</style>
